import { Component, Input } from '@angular/core';
import { ScheduledMaintenanceTask } from './scheduled-maintenance-task.model';
import { MatFormField, MatLabel, MatInput, MatHint } from '@angular/material/input';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MAT_MOMENT_DATE_FORMATS, MomentDateAdapter } from '@angular/material-moment-adapter'
import { FormsModule } from '@angular/forms';
import { MatExpansionPanelDescription } from '@angular/material/expansion';
import { MatCheckbox } from '@angular/material/checkbox';
import { MatSelect } from '@angular/material/select';
import { MatOption } from '@angular/material/autocomplete';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatRadioGroup, MatRadioButton } from '@angular/material/radio';
import { PascalToHumanPipe } from '../Tenant/Applications/Airsweb/maintenance-tasks/pascal-to-human.pipe';

@Component({
    selector: 'maintenance-task-config',
    templateUrl: './maintenance-task-config.component.html',
    styleUrls: ['./maintenance-task-config.component.less'],
    providers: [
        { provide: MAT_DATE_LOCALE, useValue: 'en-GB' },
        {
            provide: DateAdapter,
            useClass: MomentDateAdapter,
            deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
        },
        { provide: MAT_DATE_FORMATS, useValue: MAT_MOMENT_DATE_FORMATS },
    ],

    imports: [FormsModule, MatExpansionPanelDescription, MatFormField, MatLabel, MatInput, MatCheckbox, MatSelect, MatOption, MatButton, MatIcon, MatHint, MatRadioGroup, MatRadioButton, PascalToHumanPipe]
})
export class MaintenanceTaskConfigComponent {
    @Input() task: ScheduledMaintenanceTask;

    hasConfig(task: ScheduledMaintenanceTask): boolean {
        return task.AvailableConfigurationSettings.PropertyEditModels && task.AvailableConfigurationSettings.PropertyEditModels.length > 0;
    }

    generateDictionary(obj: any, propertyName: string): string[] {
        if (!obj[propertyName]) obj[propertyName] = {};
        return Object.keys(obj[propertyName]).filter(k => !k.startsWith("$"));
    }

    removeRow(targetObj: any[], rowKey: string): void {
        var indexToDelete = targetObj.indexOf(rowKey, 0)
        if (indexToDelete > -1) {
            targetObj.splice(indexToDelete, 1);
        }
    }

    newValuePair(dic: any, key: string, value: string, setting: any): void {
        dic[key] = value.toString();
        setting.newKey = "";
        setting.newValue = "";
    }

    generateArray(obj: any, propertyName: string): any[] {
        if (!obj[propertyName]) obj[propertyName] = [];
        return obj[propertyName];

    }

    newArrayItem(value: any, key: string, setting: any): void {
        value.push(key);
        setting.newItem = "";
    }
}